const ProfileParentsHome = () =>
  import("@/features/dep-parents/profile/views/ProfileParentsIndexView");

const ProfilePersonalData = () =>
  import("@/features/dep-parents/personal_data/views/PersonalDataView");

const ProfilePersonalDataEdit = () =>
  import("@/features/dep-parents/personal_data/views/RelativePersonalDataForm");

const ProfileInvoiceData = () =>
  import("@/features/dep-parents/invoice_data/views/InvoiceDataView");

const ProfileInvoiceDataEdit = () =>
  import("@/features/dep-parents/invoice_data/views/RelativeInvoiceEdit");

const ProfileShippingData = () =>
  import("@/features/dep-parents/shipping_data/views/ShippingDataView");

const ProfileShippingDataEdit = () =>
  import("@/features/dep-parents/shipping_data/views/RelativeShippingEdit");

const StudentAssociation = () =>
  import(
    "@/features/dep-parents/student_association/views/StudentAssociationDataView"
  );

const StudentAssociationEdit = () =>
  import(
    "@/features/dep-parents/student_association/views/RelativeStudentAssociation"
  );

const ParentsRecordPayments = () =>
  import("@/features/dep-parents/record_payments/views/RecordPaymentsListView");

const ParentPayments = () =>
  import(
    "@/features/dep-parents/payments/presentation/views/DepParentPayments"
  );
const CheckoutPayments = () =>
  import(
    "@/features/dep-parents/payments/presentation/views/RelativePaymentCheckoutView"
  );

const Banorte3DSecure = () =>
  import("@/features/dep-parents/payments/presentation/views/Banorte3DSecure");

export const profileParentsRoutes = [
  {
    path: "/profile/parents",
    component: ProfileParentsHome,
    children: [
      {
        path: "/infoUsers/read-onlyInfo",
        name: "datos-personales",
        component: ProfilePersonalData,
      },
      {
        path: "invoice-data",
        name: "datos-facturacion",
        component: ProfileInvoiceData,
      },
      {
        path: "shipping-data",
        name: "direccion-envio",
        component: ProfileShippingData,
      },
      {
        path: "student-association",
        name: "asociacion-alumnos",
        component: StudentAssociation,
      },
    ],
  },
  {
    path: "/payments/history",
    component: ParentsRecordPayments,
  },
  {
    path: "/infoUsers/read-onlyInfo/edit",
    name: "datos-personales-edit",
    component: ProfilePersonalDataEdit,
  },
  {
    path: "/invoice-data/edit",
    name: "datos-facturacion-edit",
    component: ProfileInvoiceDataEdit,
  },

  {
    path: "/shipping-data/edit",
    name: "asociacion-alumnos-edit",
    component: ProfileShippingDataEdit,
  },

  {
    path: "/student-association/edit",
    name: "datos-envio-edit",
    component: StudentAssociationEdit,
  },

  {
    path: "/infoUsers/payment",
    name: "relative-payments",
    component: ParentPayments,
  },

  {
    path: "/relative/payment/checkout",
    name: "relative-checkout",
    component: CheckoutPayments,
  },

  {
    path: "/3DSecureResponse/idPayment/:idPayment/idUser/:idUser",
    name: "3d-secure-response",
    component: Banorte3DSecure,
  },
];
